import styled from 'styled-components';

const StyledBudgetInvoicesTable = styled.div`
  position: relative;
  width: 100%;

  .amount {
    text-wrap: nowrap;
  }

  .invoice-match {
    align-items: center;
    justify-content: center;
    display: flex;

    &:hover {
      cursor: unset;
    }

    svg {
      height: 16px;
      width: 16px;
    }
  }
`;


export {
  StyledBudgetInvoicesTable,
};
